// Helpers to display property text in the current UI language.
// Descriptions and features can be provided per-language in property.translations[lang].
// Price status strings (Rented / Sold / Price on demand / Coming soon…) are translated
// via t.listing.status_*.

export const pickTranslated = (property, lang, field) => {
  if (!property) return '';
  const tr = property.translations && (
    property.translations[lang] ||
    property.translations[String(lang || '').toLowerCase()] ||
    property.translations[String(lang || '').toUpperCase()]
  );
  if (tr && tr[field] != null && tr[field] !== '') return tr[field];
  return property[field];
};

export const localizePrice = (price, t) => {
  if (!price) return '';
  const key = price.trim().toLowerCase();
  const map = {
    'rented': t.listing.status_rented,
    'sold': t.listing.status_sold,
    'price on demand': t.listing.status_price_on_demand,
    'price on request': t.listing.status_price_on_request,
    'on demand': t.listing.status_on_demand,
    'coming soon': t.listing.status_coming_soon,
  };
  return map[key] || price;
};

export const isUnavailablePrice = (price) => {
  const key = (price || '').trim().toLowerCase();
  return key === 'rented' || key === 'sold' || key === 'loué' || key === 'vendu' || key === 'verhuurd' || key === 'verkocht';
};
